import React from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { Row, Col, Space } from "antd";
import { Button, TextField, Box, Typography, FormControlLabel, Switch, InputAdornment } from "@mui/material";
import clsx from "clsx";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import moment from 'moment';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../Shared/components/Icons/Date";
import { currencyFormat, capitalizeFirstLetter, idNamingConversion } from "../../../../../helpers/utilities";
import CustomAlert from "../../../../Shared/components/CustomAlert";
import dayjs from 'dayjs';

const CustomForm = (props) => {
    const { createLoader, editLoader } = useSelector(state => state.crudReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const { unitMesurementdetails } = useSelector(state => state.productSetupReducer);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { customerGroupdetails } = useSelector(state => state.salesSetupReducer);
    const { form, view, priceId, handleClose, handleSubmit,
        handleIsActive, visible, error, changeHandler, handleProductChange, commonError,
        handleEdit, title, customObject, customerId, productApi } = props;
    const classes = customStyles();

    return (
        <PrimaryDrawer
            anchor={'right'}
            open={visible}
            variant={'temporary'}
            handleClose={() => handleClose()}
            title={`${priceId ? `${view ? 'View' : 'Edit'}` : 'Create'} ${title}`}
            width={'690px'}
            className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
            component={
                <Box
                    className={clsx(classes.customForm, classes.removeUnderline)}
                    component="form"
                    autoComplete="off"
                    onSubmit={(e) => handleSubmit(e)}>
                    <div className={classes.customFormFlex}>
                        <Row type="flex" gutter={40}>
                            {
                                commonError && <Col xxs={24} xx={24} lg={24} md={24} sm={24} xs={24}
                                    className={clsx(classes.textAlignCenter, classes.marginBottom10)}>
                                    <CustomAlert error={commonError} customClass={clsx(classes.uploadError, classes.uploadErrorBreak)} /></Col>
                            }
                            <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Price Specification</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14, classes.textCapital)}>{form?.priceSpec ? capitalizeFirstLetter(form?.priceSpec) : '---'}</Typography>
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.collectPaymentSpefic, classes.fonSize13)}>Product Specification</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.productSpec ? capitalizeFirstLetter(form?.productSpec) : '---'}</Typography>
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.collectPayment, classes.fonSize13)}>Price ID</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.salesPriceId || '---'}</Typography>
                            </Col>
                            <Col xxs={16} xx={16} lg={16} md={16} sm={12} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Product</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.product?.productName || '---'}</Typography>
                                    </> : <AutoCompleteComponent
                                        name={["Product ", <span key={"Product"} className={classes.colorRedRequired}> *</span>]}
                                        heads={[{ 'key': 'productName', 'name': 'Product Name' },
                                        { 'key': 'productId', 'name': 'Product ID' }, { 'key': 'universalProduct', 'name': 'UPI Id', 'relation': 'productId' }]}
                                        details={myProductdetails}
                                        id={idNamingConversion('Product', 'salesPrice', 'DropDown')}
                                        parentValue={customObject(myProductdetails, form?.productId)}
                                        onChange={(data) => handleProductChange(data)}
                                        position={"bottom"}
                                        searchType={(s) => productApi(s)}
                                        customClasses={classes.margin20t} parentError={error?.productId}
                                    />
                                }
                            </Col>
                            <Col sxxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Active</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.isActive ? 'Yes' : 'No'}</Typography>
                                    </> : <FormControlLabel
                                        classes={{
                                            label: clsx(classes.fonSize13, 'MuiInputLabel-shrink', classes.textFieldLableColorCustom),
                                        }}
                                        control={<Switch size='small'
                                            className={clsx(classes.customSwitch)}
                                            onChange={(e) => handleIsActive(!form?.isActive)}
                                        />}
                                        id={idNamingConversion('Status', 'salesPrice', 'Radio')}
                                        label="Active"
                                        labelPlacement="top"
                                        checked={form?.isActive}
                                        className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                    />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Unit</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.unit?.name || '---'}</Typography>
                                    </> : <AutoCompleteComponent
                                        name={["Unit ", <span key={"Unit"} className={classes.colorRedRequired}> *</span>]}
                                        heads={[{ 'key': 'name', 'name': 'Unit' },
                                        { 'key': 'description', 'name': 'Description' }]}
                                        details={unitMesurementdetails}
                                        parentValue={customObject(unitMesurementdetails, form?.unitId)}
                                        onChange={(data) => changeHandler(data.id, 'unitId')}
                                        position={"bottom"}
                                        id={idNamingConversion('Unit', 'salesPrice', 'DropDown')}
                                        customClasses={classes.margin20t}
                                        parentError={error?.unitId}
                                    />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Price</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.price ? `₹ ${currencyFormat(form?.price)}` : '---'}</Typography>
                                    </> : <TextField autoComplete='one-time-code'
                                        className={clsx(classes.margin20t)}
                                        label={["Price ", <span key={"Price"} className={classes.colorRedRequired}> *</span>]}
                                        type={'number'}
                                        variant={'standard'}
                                        onWheel={(e) => e.target.blur()}
                                        name={'price'}
                                        id={idNamingConversion('Price', 'salesPrice', 'TextField')}
                                        error={error?.price ? true : false}
                                        helperText={error?.price}
                                        disabled={(form?.dynamicPrice === 'MARGIN' || form?.dynamicPrice === 'PRICE-PURCHASE PRICE MARKUP' || form?.dynamicPrice === 'SALES PRICE BY-DISC ON MRP') ? true : false}
                                        value={form.price || ''}
                                        fullWidth
                                        InputProps={{
                                            startAdornment: <InputAdornment className={clsx(classes.textFieldColor)} position="start">₹ </InputAdornment>,
                                            classes: {
                                                input: clsx(classes.textFieldColor, classes.nonEditable)
                                            },
                                            inputProps: { step: "any" }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => e.target.value !== '' ?
                                            e.target.value < 0 ? e.target.value = 0 : changeHandler(e) : changeHandler(e)}
                                    />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Dynamic Price</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.dynamicPrice ? capitalizeFirstLetter(form?.dynamicPrice) : '---'}</Typography>
                                    </> : <AutoCompleteComponent
                                        name={["Dynamic Price ", <span key={"Dynamic Price"} className={classes.colorRedRequired}> *</span>]}
                                        heads={[{ 'key': 'label', 'name': 'Dynamic Price' }]}
                                        details={[{ "label": "Sales Price", "id": "SALES PRICE" },
                                        { "label": "Margin", "id": "MARGIN" }, { "label": "Purch Price Markup", "id": "PRICE-PURCHASE PRICE MARKUP" },
                                        { "label": "Sales Price by-Disc on MRP", "id": "SALES PRICE BY-DISC ON MRP" },
                                        ]}
                                        id={idNamingConversion('Dynamic Price', 'salesPrice', 'DropDown')}
                                        parentValue={customObject([{ "label": "Sales Price", "id": "SALES PRICE" }, { "label": "Margin", "id": "MARGIN" },
                                        { "label": "Purch Price Markup", "id": "PRICE-PURCHASE PRICE MARKUP" }, { "label": "Sales Price by-Disc on MRP", "id": "SALES PRICE BY-DISC ON MRP" }], form?.dynamicPrice)}
                                        onChange={(data) => changeHandler(data.id, 'dynamicPrice')}
                                        position={"bottom"}
                                        customClasses={classes.margin20t}
                                        parentError={error?.dynamicPrice}
                                    />
                                }
                            </Col>
                            {
                                form?.dynamicPrice === 'SALES PRICE BY-DISC ON MRP' && <>
                                    <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                        {
                                            view ? <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Discount Percentage</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.discountPercentage || '---'}</Typography>
                                            </> : <TextField autoComplete='one-time-code'
                                                className={clsx(classes.margin20t)}
                                                label={["Discount Percentage % ", <span key={"Discount Percentage"} className={classes.colorRedRequired}> *</span>]}
                                                type={'number'}
                                                variant={'standard'}
                                                onWheel={(e) => e.target.blur()}
                                                id={idNamingConversion('Discount Percentage', 'salesPrice', 'TextField')}
                                                name={'discountPercentage'}
                                                error={error?.discountPercentage ? true : false}
                                                helperText={error?.discountPercentage}
                                                value={form?.discountPercentage || ''}
                                                fullWidth
                                                InputProps={{
                                                    classes: {
                                                        input: clsx(classes.textFieldColor, classes.nonEditable)
                                                    },
                                                    inputProps: { step: "any" }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => {
                                                    if (e.target.value !== '') {
                                                        if (e.target.value < 1) {
                                                            e.target.value = 1;
                                                            changeHandler(e);
                                                        } else if (e.target.value >= 100) {
                                                            e.target.value = 99.99;
                                                            changeHandler(e);
                                                        } else {
                                                            changeHandler(e)
                                                        }
                                                    } else {
                                                        changeHandler(e)
                                                    }
                                                }}
                                            />
                                        }
                                    </Col>
                                    <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Discount Amount</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                            {form?.discountAmount ? (form?.discountAmount).toFixed(2) : '---'}
                                        </Typography>
                                    </Col>
                                    <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}></Col>
                                </>
                            }
                            <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                    {
                                        view ? <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>From Date</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                {form.fromDate ? moment(form.fromDate).format('DD MMM YYYY') : '---'}
                                            </Typography>
                                        </> : <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                minDate={new Date()}
                                                value={form?.fromDate ? dayjs(form?.fromDate).$d : null}
                                                label={"From Date"}
                                                name={"fromDate"}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        id: idNamingConversion('From Date', 'salesPrice', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                format="dd/MM/yyyy"
                                                onChange={(newValue, newError) => {
                                                    if (newError?.validationError) {
                                                        changeHandler(new Date(), 'fromDate')
                                                    } else {
                                                        changeHandler(newValue, 'fromDate')
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    }
                                </div>
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                    {
                                        view ? <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>To Date</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                {form.toDate ? moment(form.toDate).format('DD MMM YYYY') : '---'}
                                            </Typography>
                                        </> : <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                minDate={form?.fromDate ? new Date(form?.fromDate) : new Date()}
                                                value={form?.toDate ? dayjs(form?.toDate).$d : null}
                                                label={"To Date"}
                                                name={"toDate"}
                                                slotProps={{
                                                    textField: {
                                                        error: error?.toDate ? true : false,
                                                        helperText: error?.toDate,
                                                        id: idNamingConversion('To Date', 'salesPrice', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor
                                                    }
                                                }}
                                                format="dd/MM/yyyy"
                                                onChange={(newValue, newError) => {
                                                    if (newError?.validationError) {
                                                        changeHandler(new Date(), 'toDate')
                                                    } else {
                                                        changeHandler(newValue, 'toDate')
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    }
                                </div>
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}></Col>
                            {/* <Col span={8}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>From Quantity</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                            {form?.fromQuantity || '---'}
                                        </Typography>
                                    </> : <TextField autoComplete='one-time-code'
                                        className={clsx(classes.margin20t)}
                                        label={["From Quantity ", <span key={"From Quantity"} className={classes.colorRedRequired}> *</span>]}
                                        type={'number'}
                                        variant={'standard'}
                                        name={'fromQuantity'}
                                        min="1"
                                        onWheel={(e) => e.target.blur()}
                                        error={error?.fromQuantity ? true : false}
                                        helperText={error?.fromQuantity}
                                        value={form?.fromQuantity || ''}
                                        fullWidth
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => e.target.value !== '' ? e.target.value < 1 ? e.target.value = 1 : changeHandler(e) : changeHandler(e)}
                                    />
                                }
                            </Col>
                            <Col span={8}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>To Quantity</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                            {form?.toQuantity || '---'}
                                        </Typography>
                                    </> : <TextField autoComplete='one-time-code'
                                        className={clsx(classes.margin20t)}
                                        label={["To Quantity ", <span key={"To Quantity"} className={classes.colorRedRequired}> *</span>]}
                                        type={'number'}
                                        variant={'standard'}
                                        name={'toQuantity'}
                                        min="1"
                                        onWheel={(e) => e.target.blur()}
                                        error={error?.toQuantity ? true : false}
                                        helperText={error?.toQuantity}
                                        value={form?.toQuantity || ''}
                                        fullWidth
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => e.target.value !== '' ? e.target.value < 1 ? e.target.value = 1 : changeHandler(e) : changeHandler(e)}
                                    />
                                }
                            </Col>
                            <Col span={8}></Col> */}
                            <>
                                <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                    {
                                        (view || customerId) ? <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer specification </Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                {form?.customerSpec ? capitalizeFirstLetter(form?.customerSpec) : ''}
                                            </Typography>
                                        </> : <AutoCompleteComponent
                                            name={["Customer Specification ", <span key={"Customer specification"} className={classes.colorRedRequired}> *</span>]}
                                            heads={[{ 'key': 'label', 'name': 'Specification' }]}
                                            details={[{ "label": "Specific Customer", "id": "SPECIFIC" }, { "label": "Group of Customer", "id": "GROUP" }, { "label": "All Customer", "id": "ALL" }]}
                                            parentValue={customObject([{ "label": "Specific Customer", "id": "SPECIFIC" }, { "label": "Group of Customer", "id": "GROUP" }, { "label": "All Customer", "id": "ALL" }], form?.customerSpec)}
                                            onChange={(data) => changeHandler(data.id, 'customerSpec')}
                                            position={"bottom"}
                                            id={idNamingConversion('Customer Specification', 'salesPrice', 'DropDown')}
                                            customClasses={classes.margin20t}
                                            parentError={error?.customerSpec}
                                        />
                                    }
                                </Col>
                                {
                                    form?.customerSpec === 'GROUP' ? <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                        {
                                            view ? <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Customer Group Name</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customerGroup?.name || '---'}</Typography>
                                            </> :
                                                <AutoCompleteComponent
                                                    name={["Customer Group ", form?.customerSpec === 'GROUP' && <span key={"Customer Group"} className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'name', 'name': 'Name' },
                                                    { 'key': 'description', 'name': 'Description' }]}
                                                    details={customerGroupdetails}
                                                    parentValue={customObject(customerGroupdetails, form?.customerGroupId)}
                                                    onChange={(data) => changeHandler(data.id, 'customerGroupId')}
                                                    position={"bottom"}
                                                    id={idNamingConversion('Customer Group', 'salesPrice', 'DropDown')}
                                                    customClasses={classes.margin20t}
                                                    parentError={error?.customerGroupId}
                                                />
                                        }
                                    </Col> : <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                        {
                                            form?.customerSpec === 'SPECIFIC' ? <>
                                                {
                                                    (view || customerId) ? <>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Customer Name</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer?.name || '---'}</Typography>
                                                    </> :
                                                        <AutoCompleteComponent
                                                            name={["Customer Name ", form?.customerSpec === 'SPECIFIC' && <span key={"Customer Name"} className={classes.colorRedRequired}> *</span>]}
                                                            heads={[{ 'key': 'name', 'name': 'Customer Name' },
                                                            { 'key': 'mobile', 'name': 'Phone Number' },
                                                            { 'key': 'serialNo', 'name': 'Customer ID' }]}
                                                            details={customerDetails}
                                                            id={idNamingConversion('Customer Name', 'salesPrice', 'DropDown')}
                                                            parentValue={customObject(customerDetails, form?.customerId)}
                                                            onChange={(data) => { changeHandler(data.id, 'customerId') }}
                                                            position={"bottom"}
                                                            customClasses={classes.margin20t}
                                                            parentError={error?.customerId}
                                                        />
                                                }
                                            </> : <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14, classes.margin20t)}>---</Typography>
                                        }

                                    </Col>
                                }
                            </>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Margin %</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.margin ? `${form?.margin}%` : '---'}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            className={clsx(classes.margin20t)}
                                            label={form?.dynamicPrice === 'MARGIN' ? ["Margin % ", <span key={"Margin"} className={classes.colorRedRequired}> *</span>] : ["Margin % "]}
                                            type={'number'}
                                            onWheel={(e) => e.target.blur()}
                                            variant={'standard'}
                                            name={'margin'}
                                            error={error?.margin ? true : false}
                                            helperText={error?.margin}
                                            id={idNamingConversion('Margin', 'salesPrice', 'TextField')}
                                            value={form?.margin || ''}
                                            disabled={(form?.dynamicPrice === 'SALES PRICE' || form?.dynamicPrice === 'PRICE-PURCHASE PRICE MARKUP' || form?.dynamicPrice === 'SALES PRICE BY-DISC ON MRP') ? true : false}
                                            fullWidth
                                            InputProps={{
                                                classes: {
                                                    input: clsx(classes.textFieldColor, classes.nonEditable)
                                                },
                                                inputProps: { step: "any" }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                                shrink: Number.isFinite(parseFloat(form?.margin))
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Purch Price Markup</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.markup || '---'}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            className={clsx(classes.margin20t)}
                                            label={form?.dynamicPrice === 'PRICE-PURCHASE PRICE MARKUP' ? ["Purch Price Markup ", <span key={"Purch Price Markup"} className={classes.colorRedRequired}> *</span>] : ["Purch Price Markup"]}
                                            type={'number'}
                                            variant={'standard'}
                                            id={idNamingConversion('Purch Price Markup', 'salesPrice', 'TextField')}
                                            onWheel={(e) => e.target.blur()}
                                            name={'markup'}
                                            error={error?.markup ? true : false}
                                            helperText={error?.markup}
                                            value={form?.markup || ''}
                                            disabled={(form?.dynamicPrice === 'SALES PRICE' || form?.dynamicPrice === 'MARGIN' || form?.dynamicPrice === 'SALES PRICE BY-DISC ON MRP') ? true : false}
                                            fullWidth
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                inputProps: { step: "any" }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? e.target.value = 0 : changeHandler(e) : changeHandler(e)}
                                        />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Cost Price</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.cost || '---'}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            className={clsx(classes.margin20t)}
                                            label={["Cost Price"]}
                                            type={'number'}
                                            variant={'standard'}
                                            onWheel={(e) => e.target.blur()}
                                            name={'cost'}
                                            error={error?.cost ? true : false}
                                            helperText={error?.cost}
                                            value={form?.cost || ''}
                                            fullWidth
                                            id={idNamingConversion('Cost Price', 'salesPrice', 'TextField')}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                inputProps: { step: "any" }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? e.target.value = 0 : changeHandler(e) : changeHandler(e)}
                                        />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Latest Purchase Price</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.lastPurchasePrice || '---'}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            className={clsx(classes.margin20t)}
                                            label={["Latest Purchase Price "]}
                                            type={'number'}
                                            id={idNamingConversion('Latest Purchase Price', 'salesPrice', 'TextField')}
                                            onWheel={(e) => e.target.blur()}
                                            variant={'standard'}
                                            name={'lastPurchasePrice'}
                                            error={error?.lastPurchasePrice ? true : false}
                                            helperText={error?.lastPurchasePrice}
                                            value={form?.lastPurchasePrice || ''}
                                            fullWidth
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                inputProps: { step: "any" }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                {
                                    view ?
                                        <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Use MRP</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                {form?.useMRP ? 'Yes' : 'No'}
                                            </Typography>
                                        </> :
                                        <FormControlLabel
                                            classes={{
                                                label: clsx(classes.fonSize13, classes.noWrap, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink'), // Pass your override css here
                                            }}
                                            control={<Switch size='small' className={clsx(classes.customSwitch)}
                                                onChange={(e) => changeHandler(e, 'useMRP')}
                                            />}
                                            id={idNamingConversion('Use MRP', 'salesPrice', 'Radio')}
                                            label="Use MRP"
                                            labelPlacement="top"
                                            checked={form?.useMRP ? true : false}
                                            className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                        />
                                }
                            </Col>
                            <Col xxs={8} xx={8} lg={8} md={8} sm={12} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>MRP</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.maxRetailPrice || '---'}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            className={clsx(classes.margin20t)}
                                            label={["MRP "]}
                                            variant={'standard'}
                                            onWheel={(e) => e.target.blur()}
                                            name={'maxRetailPrice'}
                                            id={idNamingConversion('MRP', 'salesPrice', 'TextField')}
                                            error={error?.maxRetailPrice ? true : false}
                                            helperText={error?.maxRetailPrice}
                                            value={form?.maxRetailPrice || ''}
                                            fullWidth
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                inputProps: { step: "any" }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? e.target.value = 0 : changeHandler(e) : changeHandler(e)}
                                        />
                                }
                            </Col>
                            <Col span={8}></Col>
                            <Col span={8}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>S.E.D- Special Excise Duty (%)</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.specialExcisesDutyPercentage || '---'}</Typography>
                                    </> : <>
                                        {
                                            !form?.useMRP ? <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>S.E.D- Special Excise Duty (%)</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.specialExcisesDutyPercentage || '---'}</Typography>
                                            </> : <TextField autoComplete='one-time-code'
                                                className={clsx(classes.margin20t)}
                                                label={["S.E.D- Special Excise Duty (%)"]}
                                                type={'number'}
                                                id={idNamingConversion('S.E.D- Special Excise Duty  (%)', 'salesPrice', 'TextField')}
                                                onWheel={(e) => e.target.blur()}
                                                variant={'standard'}
                                                name={'specialExcisesDutyPercentage'}
                                                value={form?.specialExcisesDutyPercentage || ''}
                                                fullWidth
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    },
                                                    inputProps: { step: "any" }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e.target.value, 'specialExcisesDutyPercentage')}
                                            />
                                        }
                                    </>
                                }
                            </Col>
                            <Col span={8}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>S.E.D- Special Excise Duty</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.specialExcisesDuty || '---'}</Typography>
                                    </> : <>
                                        {
                                            form?.useMRP ? <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>S.E.D- Special Excise Duty</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.specialExcisesDuty || '---'}</Typography>
                                            </> : <TextField autoComplete='one-time-code'
                                                className={clsx(classes.margin20t)}
                                                label={["S.E.D- Special Excise Duty"]}
                                                type={'number'}
                                                id={idNamingConversion('S.E.D- Special Excise Duty', 'salesPrice', 'TextField')}
                                                onWheel={(e) => e.target.blur()}
                                                variant={'standard'}
                                                name={'specialExcisesDuty'}
                                                value={form?.specialExcisesDuty || ''}
                                                fullWidth
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    },
                                                    inputProps: { step: "any" }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e.target.value, 'specialExcisesDuty')}
                                            />
                                        }
                                    </>

                                }
                            </Col>
                            {/* <Col span={8}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Default Price</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.defaultPrice || '---'}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            className={clsx(classes.margin20t)}
                                            label={["Default Price"]}
                                            type={'number'}
                                            variant={'standard'}
                                            name={'defaultPrice'}
                                            error={error?.defaultPrice ? true : false}
                                            helperText={error?.defaultPrice}
                                            value={form?.defaultPrice || ''}
                                            fullWidth
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                step: "any"
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => e.target.value !== '' ? e.target.value < 1 ? e.target.value = 1 : changeHandler(e) : changeHandler(e)}
                                        />
                                }
                            </Col> */}
                        </Row>
                    </div>
                    {
                        handleEdit && <div className={clsx(classes.btnParent)}>
                            {
                                !view ?
                                    <Space size={[10, 10]} direction="horizontal" align="center">
                                        <Button
                                            key="save"
                                            color="primary"
                                            variant="contained"
                                            type={'submit'}
                                            id={idNamingConversion('Save', 'salesPrice', 'Button')}
                                            className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                            {
                                                priceId ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                    </Space> : <NavLink to={'#'} id={idNamingConversion('Edit', 'salesPrice', 'Link')} className={clsx(classes.modalBtn)} onClick={() => handleEdit(false)}>Edit</NavLink>
                            }
                        </div>
                    }
                </Box>
            }
        />
    )
}

export default CustomForm;